import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-vpn.configuration', {
        url: '/configuration',
        component: 'configuration',
        // resolve: {settings},
    });
}

/** @ngInject */
function settings(companyId,SaaspassVpnService) {
    return SaaspassVpnService.get(companyId);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-vpn/configuration/configuration.state.js